export default "__VITE_ASSET__DPfqWryR__"